module.exports = __webpack_public_path__ + "img/u892.12598a81.png";